var _ellipse, _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobilePreEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 65.0862,
    rx: 60,
    ry: 60,
    transform: "rotate(-90 65 65.0862)",
    fill: "url(#paint0_linear_641_6801)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_641_6801)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.4883,
    y: 24.5734,
    width: 82.0513,
    height: 82.0513,
    rx: 41.0256,
    fill: "#5449C5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5149 80.6417H69.0363C69.0363 82.7187 67.3525 84.4024 65.2756 84.4024C63.1986 84.4024 61.5149 82.7187 61.5149 80.6417Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2755 46.7957C64.237 46.7957 63.3951 47.6375 63.3951 48.676V50.5563C63.3951 50.6085 63.3973 50.6602 63.4014 50.7113C58.0625 51.6039 53.9935 56.246 53.9935 61.8384V65.5189C53.9935 66.3288 53.7003 67.1113 53.1682 67.7218L51.9564 69.1119C48.0325 73.6136 51.2297 80.6418 57.2014 80.6418H73.3496C79.3214 80.6418 82.5186 73.6136 78.5947 69.1119L77.3829 67.7218C76.8508 67.1113 76.5576 66.3288 76.5576 65.5189V61.8384C76.5576 56.2459 72.4885 51.6038 67.1495 50.7113C67.1537 50.6602 67.1558 50.6085 67.1558 50.5563V48.676C67.1558 47.6375 66.314 46.7957 65.2755 46.7957ZM57.7542 61.8384C57.7542 57.6845 61.1216 54.317 65.2756 54.317C69.4295 54.317 72.7969 57.6845 72.7969 61.8384V65.5189C72.7969 67.2372 73.4189 68.8975 74.548 70.1928L75.7598 71.583C77.5629 73.6516 76.0937 76.8811 73.3496 76.8811H57.2014C54.4573 76.8811 52.9882 73.6516 54.7913 71.583L56.0031 70.1928C57.1322 68.8975 57.7542 67.2372 57.7542 65.5189V61.8384Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_6801",
    x: 0.488281,
    y: 0.573364,
    width: 154.051,
    height: 154.051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.113725 0 0 0 0 0.298039 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_6801"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_6801",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_6801",
    x1: 65.0906,
    y1: 3.0349,
    x2: 65.0906,
    y2: 125.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463DA3",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383179"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePreEvent);
export default __webpack_public_path__ + "static/media/mobile-pre-event.7cb07336ebbe38bfecf9c47b2f15d85c.svg";
export { ForwardRef as ReactComponent };